// Async AI generation helper. Submits job, polls for result, bypasses 60s ingress timeout.
import { api } from "@/lib/api";

/** Intake: OCR + αυτόματη εξαγωγή πεδίων υπόθεσης από ανεβασμένο έγγραφο, πριν
 * υπάρξει ακόμα case_id. Επιστρέφει {ok, confidence, fields|message}. */
export async function extractIntakeFields(file, model = "claude") {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("model", model);
  const { data } = await api.post("/intake/extract-fields", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function runAIPrompt({ prompt_key, case_id, model = "claude", custom_instructions, witness_id, onProgress }) {
  const { data: job } = await api.post("/ai/generate-async", {
    prompt_key, case_id, model, custom_instructions, witness_id,
  });
  const jobId = job.job_id;

  for (let i = 0; i < 90; i++) { // up to ~3 minutes
    await new Promise(r => setTimeout(r, 2000));
    const { data: status } = await api.get(`/ai/jobs/${jobId}`);
    if (onProgress) onProgress(status, i);
    if (status.status === "done") return status;
    if (status.status === "error") {
      const msg = status.error_code === "budget_exceeded"
        ? "Το πιστωτικό όριο του AI έχει εξαντληθεί. Προσθέστε credits ή αναβαθμίστε πλάνο."
        : status.error_code === "provider_unavailable"
        ? "Το AI provider δεν αποκρίνεται. Δοκιμάστε ξανά."
        : (status.error_message || "Σφάλμα AI");
      const e = new Error(msg);
      e.code = status.error_code;
      throw e;
    }
  }
  throw new Error("Η δημιουργία AI πήρε πολύ ώρα. Δοκιμάστε ξανά.");
}
